if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"room_checkout","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(default\-webpack_sharing_consume_default_(angular_core_angular|core)_core|vendor)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}